import { render, staticRenderFns } from "./ModalAvisoComprasPrazo.vue?vue&type=template&id=5ce6b312&"
import script from "./ModalAvisoComprasPrazo.vue?vue&type=script&lang=js&"
export * from "./ModalAvisoComprasPrazo.vue?vue&type=script&lang=js&"
import style0 from "./ModalAvisoComprasPrazo.vue?vue&type=style&index=0&id=5ce6b312&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports